"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BodhiProvider = void 0;
const api_1 = require("@polkadot/api");
const base_provider_1 = require("./base-provider");
const api_2 = require("@acala-network/api");
class BodhiProvider extends base_provider_1.BaseProvider {
    constructor(apiOptions) {
        super();
        const api = new api_1.ApiPromise((0, api_2.options)(apiOptions));
        this.setApi(api);
    }
    static from(apiOptions) {
        return new BodhiProvider(apiOptions);
    }
}
exports.BodhiProvider = BodhiProvider;
